<template>
  <div>
    <Navbar />
    <br/>
    <div class="bg bg--about" style="margin-top: 55px;">
      <div class="bg--overlay bg--overlay__ab"></div>
      <section class="sections">
        <v-container>
          <v-row align="center">
            <v-col cols="12" sm="6">
              <div class="sections-box">
                <div class="sections--border">
                  <span class="sections--title">About</span>
                  <h2 class="sections--menu">About Songket</h2>
                </div>
              </div>
              <div class="my-10">
                <p>
                  One songket cloth might be just an ordinary fabric at one glance, but from cotton, silk, or plant fiber strands, they become a unique Indonesian heritage with embossed decorative patterns on its surface. These motifs—made from gold, silver, plant fiber, or cotton threads—were a fragment of the weavers’ imagination and interpretation of the local nature, brought into life. Most of these patterns are derived from the imagery of floral and animal lives, geometric, as well as mythological beings.
                </p>
                <p>
                  The songket-weaving tradition is spread all over Indonesia; From Sumatra to Papua, each of the regions exhibits their own unique characteristics. Songket, too, is not only rich in terms of its endless creativity in patterns and motifs, but also serves countless purposes in the lives of Indonesians. You can find songket playing huge roles in various life cycle events, from birth celebrations, weddings, to funerals—it is not a mere, mundane cloth. From its intricately woven threads, songket has passed down a precious heritage to the forthcoming generations: Indonesia’s collective memory from the past, its cultural identity, and reflection of its diverse society.
                </p>
              </div>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex justify-center">
              <div class="sections--img">
                <div class="sections--img__zindex">
                  <div class="d-flex">
                    <img
                      class="sections--img__resp"
                      alt="gambar"
                      src="@/assets/img/about.png"
                    />
                  </div>
                </div>
              </div>
            </v-col>
          </v-row>
          <v-row>
            <div class="footers--sosmed">
              <!-- <p class="mb-0">Share</p> -->
              <v-btn
                v-for="(social, i) in socials"
                :key="i"
                class="footers--sosmed__icon"
                fab
                icon
              >
                <v-icon>{{ social.icon }}</v-icon>
              </v-btn>
            </div>
          </v-row>
        </v-container>
      </section>
      <Testimonial />
    </div>
    <Cta />
    <Footer />
  </div>
</template>

<script>
import Navbar from "../components/TheNavbar";
import Footer from "../components/TheFooter";
import Testimonial from "../components/TheTestimonial.vue";
import Cta from "../components/TheCta";

export default {
  name: "Detail",
  components: {
    Navbar,
    Footer,
    Testimonial,
    Cta
  },
  data() {
    return {
      details: [
        "Inventory No. 123455",
        "Gold, silk",
        "South Sumatra",
        "Aquired in 1879",
        "Technique"
      ],
      socials: [
        {
          icon: "mdi-facebook"
        },
        {
          icon: "mdi-twitter"
        },
        {
          icon: "mdi-instagram"
        }
      ]
    };
  },
  created() {
    window.scrollTo(0,0);
  }
};
</script>

<style lang="scss" scoped></style>
